import React from "react";

const Subtitle: React.FC = () => {
    return (
        <>
            <p>
                Discover when people visit the selected retail centre and how long they stay.
                These patterns help you understand how well the centre draws in and holds shopper attention.
            </p>
        </>
    );
};

export default Subtitle;
